var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPersons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .IconPersons_a {\n        fill: #085170;\n        opacity: 0.5;\n      }\n\n      .IconPersons_b {\n        fill: #fff;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "IconPersons_a",
    width: 42,
    height: 42,
    rx: 21
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.017 11.154)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "IconPersons_b",
    d: "M19.727,8.821a1.288,1.288,0,0,0-.059-.265V8.468a1.052,1.052,0,0,0-.187-.275h0l-5.9-5.9h0a1.052,1.052,0,0,0-.275-.187H13.22L12.905,2H6.949A2.949,2.949,0,0,0,4,4.949V18.71a2.949,2.949,0,0,0,2.949,2.949h9.829a2.949,2.949,0,0,0,2.949-2.949V8.821Zm-5.9-3.47L16.375,7.9H13.829Z",
    transform: "translate(-4 -2)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersons);
export default __webpack_public_path__ + "static/media/IconPersons.12337ad3a2156ed3ff8193520c51f57e.svg";
export { ForwardRef as ReactComponent };